import { uniqBy } from 'lodash'

const mutations = {

  SET_INIT_DATA(state, data) {
    state.data = data
  },
  SET_FEATURES_KEYS(state, data) {
    state.feturesKeys = data
  },
  SET_INIT_FLAG(state) {
    state.initialized = true
  },

  // not in use
  INIT_ALL_CATEGORIES(state, data) {
    let allData = data

    function baseMapItem(category, item) {
      category.NameInHebrew = item.NameInHebrew
      category.Code = item.Code
      category.NumberOfJobs = item.NumberOfJobs
      return category
    }
    let tempCats = []
    let tempSubCats = []
    allData.forEach(item => {
      let superCat = {
        Areas: []
      }
      item.Areas.forEach(i => {
        let category = {}
        baseMapItem(category, i)
        category.query = 'subcat'
        category.category = item.NameInHebrew
        category.parent = superCat
        tempSubCats.push(category)
        superCat.Areas.push(category)
      })

      baseMapItem(superCat, item)
      superCat.Areas = item.Areas
      superCat.query = 'catdir'
      tempCats.push(superCat)
    })

    state.allCategories = [...tempCats]
    state.allSubCategories = uniqBy([...tempSubCats], 'Code')
  },

  SET_ERROR(state, error) {
    state.errors.push(error)
  },
  SET_SANITIZED(state) {
    state.sanitized = true
  },

  IS_NATIVE_DEVICE(state, data) {
    state.nativeDevice = data
  },
  UPDATE_INAPP_GTM_FLAG(state, data) {
    state.firedInAppGtmFlag = data
  }

}

export default mutations
